import { Button } from '@mui/material';
import React from 'react';
import { fullname } from '../helpers';

function PersonalDetails(props)
{
	const { payload, setEditprofileOpen } = props;

	return (
		<div className='flexCol pdngSM'>
			<div className='flexRow pdngVMD'>
				<div className='flexMinWidthCol'>
					<h4>Personal Details</h4>
				</div>
				<div className='flexAutoCol'>
					<Button variant='outlined' size='small' color='primary' onClick={() => setEditprofileOpen(true)}>edit</Button>
				</div>
			</div>
			<div className='flexRow alignCntr pdngVXSM'>
				<span className='profileKeysTxtSM'>Name: </span>
				<span className='valTxtMD'> {fullname(payload)}</span>
			</div>
			<div className='flexRow alignCntr pdngVXSM'>
				<span className='profileKeysTxtSM'>Email: </span>
				<span className='valTxtMD txtPrimary'> {payload?.email}</span>
			</div>
			<div className='flexRow alignCntr pdngVXSM'>
				<span className='profileKeysTxtSM'>Phone: </span>
				<span className='valTxtMD'> {payload?.phone}</span>
			</div>
			{payload?.teamName && <div className='flexRow alignCntr pdngVXSM'>
				<span className='profileKeysTxtSM'>Team Name: </span>
				<span className='valTxtMD'> {payload?.teamName}</span>
			</div>}
			{payload?.companyName && <div className='flexRow alignCntr pdngVXSM'>
				<span className='profileKeysTxtSM'>Company Name: </span>
				<span className='valTxtMD'> {payload?.companyName}</span>
			</div>}
		</div>
	);
}

export default PersonalDetails;
